import { Component, OnDestroy, OnInit } from '@angular/core';
import { MyClientsReSingRespondeModel } from '@app/models/myClientsReSingResponse.model';
import { SubjectService } from '@app/services/subject.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-promissory-note-toogle',
  templateUrl: './promissory-note-toogle.component.html',
  styleUrls: ['./promissory-note-toogle.component.scss']
})
export class PromissoryNoteToogleComponent implements OnInit, OnDestroy {
  public enableToogle: boolean = false;
  public value: boolean = false;

  private readonly unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private subjectStore: SubjectService
  ) {

  }

  ngOnInit(): void {
    this.subjectStore.dataClientReSign$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(this.setDataClientReSingSubs.bind(this));
  }

  setDataClientReSingSubs(response: MyClientsReSingRespondeModel) {
    const { habilitarPagareToogle = false } = response;
    // const habilitarPagareToogle = false;
    this.enableToogle = habilitarPagareToogle;
    this.onChange(!habilitarPagareToogle); // En caso de que no se habilité el toogle, es porque si o si debe de firmar el pagaré
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onChange(value: boolean) {
    this.value = value;
    this.subjectStore.setPromissoryNoteToogle(value);
  }
}
